import { useMemo } from "react";

export type Sort = "asc" | "desc";

const makeSortToggler =
    <TField>({
        defaultSortBy,
        defaultSort,
    }: {
        defaultSortBy: TField | undefined;
        defaultSort: Sort;
    }) =>
    ({
        currentSortBy = defaultSortBy,
        currentSort = defaultSort,
        nextSortBy,
    }: {
        currentSortBy: TField | undefined;
        currentSort: Sort | undefined;
        nextSortBy: TField | undefined;
    }): [TField | undefined, Sort | undefined] => {
        let nextSort: Sort | undefined;
        if (currentSortBy === nextSortBy) {
            nextSort = currentSort === "asc" ? "desc" : "asc";
        } else {
            nextSort = defaultSort;
        }

        return [
            nextSortBy === defaultSortBy ? undefined : nextSortBy,
            nextSort === defaultSort ? undefined : nextSort,
        ];
    };

export const useSortToggler = <TField>({
    defaultSortBy,
    defaultSort,
}: {
    defaultSortBy: TField | undefined;
    defaultSort: Sort;
}) => {
    return useMemo(
        () => makeSortToggler<TField>({ defaultSortBy, defaultSort }),
        [defaultSortBy, defaultSort],
    );
};
